{
    "general": {
        "custom_text": {
            "login": "Login ",
            "contact_us": "Contact us",
            "show_more_collection": "show more",
            "hide_collection": "hide",
            "show_more_specification": "show more characteristics",
            "hide_specification": "hide",
            "product": "product",
            "products": "products",
            "new_product": "New",
            "login_page": {
                "remember_me": "Remember me"
            },
            "signup_page": {
                "company": "Company",
                "signup_failed": "Registration request failed, please try again later or contact Customer Service.",
                "signup_success": "Registration request sent, you will be contacted to confirm your details.",
                "account_area_disclaimer": "The reserved area will be available soon.",
                "role_options": "Customer, Agent, Third-party account",
                "sector_options": "Resale, Production, Construction"
            },
            "specifications_product": {
                "Antivibranti_Base": "Material base",
                "Antivibranti_Boccola": "Material bushing",
                "Antivibranti_Campana": "Material bell",
                "Antivibranti_Colore": "",
                "Antivibranti_Corpo": "Material body",
                "Antivibranti_Din": "Standard",
                "Antivibranti_DurezzaGomma": "Rubber hardness",
                "Antivibranti_Materiale": "",
                "Antivibranti_Norma": "Standard",
                "Antivibranti_Note": "Notes",
                "Antivibranti_Perno": "Material pin",
                "Antivibranti_Rondella": "Material washer",
                "Antivibranti_TempEsercizio": "Operating temperature",
                "brand": "Brand",
                "Cerniere_Colore": "",
                "Cerniere_FinituraSuperficialeFlange": "",
                "Cerniere_FinituraSuperficialeSpina": "",
                "Cerniere_FinituraSuperficialeSupporto": "",
                "Cerniere_MaterialeBase": "",
                "Cerniere_MaterialeBaseSupportoSpina": "Material base, support and pin",
                "Cerniere_MaterialeBoccolaPosizione": "Material bush",
                "Cerniere_MaterialeCoperchio": "",
                "Cerniere_MaterialeCorpo": "Material body",
                "Cerniere_MaterialeDado": "Material nut",
                "Cerniere_MaterialeFlange": "Material flanges",
                "Cerniere_MaterialeMolla": "Material spring",
                "Cerniere_MaterialePerniFilettati": "",
                "Cerniere_MaterialePerno": "Material pins",
                "Cerniere_MaterialePernoAllogiamento": "Material housing pin",
                "Cerniere_MaterialeRondella": "Material washer",
                "Cerniere_MaterialeRondellaAntifrizionamento": "Material washer",
                "Cerniere_MaterialeRondellaAntigrippaggio": "Material anti-seize bushing",
                "Cerniere_MaterialeSeeger": "Material seeger",
                "Cerniere_MaterialeSfere": "Material ball",
                "Cerniere_MaterialeSpina": "Material pin",
                "Cerniere_MaterialeSpinaArresto": "Material stop pin",
                "Cerniere_MaterialeVite": "Material screw",
                "Cerniere_Note": "Notes",
                "Cerniere_Tipo": "",
                "Cerniere_TrattamentoSuperficialeBase": "",
                "Cerniere_TrattamentoSuperficialeDado": "",
                "Cerniere_TrattamentoSuperficialeFlange": "",
                "Cerniere_TrattamentoSuperficialeMolla": "",
                "Cerniere_TrattamentoSuperficialePerniFilettati": "",
                "Cerniere_TrattamentoSuperficialePerno": "",
                "Cerniere_TrattamentoSuperficialePernoAllogiamento": "",
                "Cerniere_TrattamentoSuperficialeSeegers": "",
                "Cerniere_TrattamentoSuperficialeSpina": "",
                "Cerniere_TrattamentoSuperficialeSpinaArresto": "",
                "Cerniere_Versione": "",
                "ChiusureLeva_Accessori": "",
                "ChiusureLeva_Materiale": "Material",
                "ChiusureLeva_Note": "Notes",
                "ChiusureLeva_TrattamentoSuperficiale": "",
                "class": "Class",
                "clothesColor": "Color",
                "clothesMeasure": "Size",
                "color": "Color",
                "degree": "Degree",
                "din": "DIN",
                "Distanziatori_Adesivo": "Adhesive",
                "Distanziatori_Autoestinguenza": "Self-extinguishing",
                "Distanziatori_Colore": "",
                "Distanziatori_Impiego": "Use",
                "Distanziatori_Materiale": "Material",
                "Distanziatori_Note": "Notes",
                "Distanziatori_TempEsercizio": "Operating temperature",
                "Distanziatori_TrattamentoSuperficiale": "",
                "ElemMeccanici_Accessori": "Accessories",
                "ElemMeccanici_Accoppiamento": "Coupling",
                "ElemMeccanici_Impiego": "Use",
                "ElemMeccanici_Materiale": "Material",
                "ElemMeccanici_MaterialeBoccola": "Material bushing",
                "ElemMeccanici_MaterialeCorpo": "Material body",
                "ElemMeccanici_MaterialeCorpoFemmina": "Material female body",
                "ElemMeccanici_MaterialeCorpoMaschio": "Material male body",
                "ElemMeccanici_MaterialeEsternoMolla": "Material external spring",
                "ElemMeccanici_MaterialeInternoMolla": "Material internal spring",
                "ElemMeccanici_MaterialeMolla": "",
                "ElemMeccanici_MaterialeSfera": "Material ball",
                "ElemMeccanici_Norma": "Standard",
                "ElemMeccanici_Note": "Notes",
                "ElemMeccanici_TrattamentoSuperficiale": "",
                "ElemMeccanici_TrattamentoSuperficialeCorpo": "",
                "ElemPosiz_Accessori": "Accessories",
                "ElemPosiz_Colore": "",
                "ElemPosiz_InsertoLongLok": "",
                "ElemPosiz_MarcaturaBloccaggio": "Lock marking",
                "ElemPosiz_Materiale": "Material",
                "ElemPosiz_MaterialeAnello": "Material ring",
                "ElemPosiz_MaterialeCapocorda": "Material cable tip",
                "ElemPosiz_MaterialeCavetto": "Material cable",
                "ElemPosiz_MaterialeCavo": "",
                "ElemPosiz_MaterialeCavoSpirale": "Material spiral cable",
                "ElemPosiz_MaterialeCorpo": "Material body",
                "ElemPosiz_MaterialeImpugnatura": "Material grip",
                "ElemPosiz_MaterialeManopola": "",
                "ElemPosiz_MaterialeMolla": "Material spring",
                "ElemPosiz_MaterialeMolle": "Material springs",
                "ElemPosiz_MaterialeMorsetto": "Material clamp",
                "ElemPosiz_MaterialeOcchiello": "Material ring",
                "ElemPosiz_MaterialePerno": "Material pin",
                "ElemPosiz_MaterialePernoBloccaggio": "Material indexing pin",
                "ElemPosiz_MaterialePulsante": "Material button",
                "ElemPosiz_MaterialePuntale": "Material pin",
                "ElemPosiz_MaterialeSfera": "Material ball",
                "ElemPosiz_MaterialeSfere": "Material balls",
                "ElemPosiz_Note": "Notes",
                "ElemPosiz_TrattamentoSuperficiale": "",
                "family": "Code",
                "endurance": "Strength",
                "Fascette_Adesivo": "Adhesive",
                "Fascette_Autoestinguenza": "Self-extinguishing",
                "Fascette_Certificazione": "Certification",
                "Fascette_Materiale": "Material",
                "Fascette_MaterialeCorpo": "Material body",
                "Fascette_MaterialeGanascia": "Material clamp",
                "Fascette_Norma": "Standard",
                "Fascette_TempEsercizio": "Operating temperature",
                "finishing": "Finishing",
                "FisaggiPressione_Codice": "",
                "FissaggioCavi_Adesivo": "Adhesive",
                "FissaggioCavi_Autoestinguenza": "Self-extinguishing",
                "FissaggioCavi_Certificazione": "Certification",
                "FissaggioCavi_Colore": "",
                "FissaggioCavi_Materiale": "Material",
                "FissaggioCavi_Norma": "Standard",
                "FissaggioCavi_Note": "Notes",
                "FissaggiPressione_Autoestinguenza": "Self-extinguishing",
                "FissaggiPressione_Colore": "",
                "FissaggiPressione_Impiego": "Use",
                "FissaggiPressione_Materiale": "Material",
                "FissaggiPressione_TempEsercizio": "Operating temperature",
                "hardness": "Hardness",
                "iso": "ISO",
                "Magneti_Grado": "Degree",
                "Magneti_Magnetizzazione": "Magnetization",
                "Magneti_Materiale": "Material",
                "Magneti_MaterialeCorpo": "Material body",
                "Magneti_MaterialeEspansore": "Material expander",
                "Magneti_MaterialeMagnete": "Material magnet",
                "Magneti_MaterialeRivestimento": "Material coating",
                "Magneti_Note": "Notes",
                "Magneti_PoloContrassegnato": "Pole marked",
                "Magneti_TempEsercizio": "Operating temperature",
                "Magneti_TrattamentoSuperficiale": "",
                "Magneti_TrattamentoSuperficialeCorpo": "",
                "Magneti_TrattamentoSuperficialeMagnete": "",
                "Maniglie_CapacitaCarico": "Load bearing capacity",
                "Maniglie_Colore": "",
                "Maniglie_CoperturaImpugnatura": "",
                "Maniglie_Dimensioni": "",
                "Maniglie_Finitura": "",
                "Maniglie_FInituraSuperficiale": "",
                "Maniglie_FinituraSuperficialeImpugnatura": "",
                "Maniglie_FinituraSuperficialeSupporto": "",
                "Maniglie_Materiale": "Material",
                "Maniglie_MaterialeBoccola": "Material bushing",
                "Maniglie_MaterialeImpugnatura": "Material grip",
                "Maniglie_MaterialeInserto": "Material insert",
                "Maniglie_MaterialePerno": "Material pin",
                "Maniglie_MaterialePressioneRondella": "Material compression washer",
                "Maniglie_MaterialePulsante": "Material button",
                "Maniglie_MaterialeRondella": "Material washer",
                "Maniglie_MaterialeSupporto": "Material supports",
                "Maniglie_MaterialeTappoCoperturaImpugnatura": "Material cover cup grip",
                "Maniglie_MaterialeTappoCoperturaSupporto": "Material cover cup support",
                "Maniglie_Note": "Notes",
                "Maniglie_TempEsercizio": "Operating temperature",
                "Maniglie_TrattamentoSuperficialeBoccola": "",
                "Maniglie_TrattamentoSuperficialeImpugnatura": "",
                "Maniglie_TrattamentoSuperficialePerno": "",
                "Maniglie_TrattamentoSuperficialeRondella": "",
                "material": "Material",
                "Molle_Colore": "",
                "Molle_Materiale": "Material",
                "Molle_Note": "Notes",
                "Molle_TrattamentoSuperficiale": "",
                "Piedini_Accessori": "Accessories",
                "Piedini_Certificazione": "Certification",
                "Piedini_Colore": "",
                "Piedini_ColoreAntiscivolo": "",
                "Piedini_ColoreBase": "",
                "Piedini_Materiale": "Material",
                "Piedini_MaterialeAntiscivolo": "Material slip-guard",
                "Piedini_MaterialeBase": "Material base",
                "Piedini_MaterialeDado": "Material nut",
                "Piedini_MaterialePerno": "Material pin",
                "Piedini_Note": "Notes",
                "Piedini_TrattamentoSuperficiale": "",
                "Piedini_TrattamentoSuperficialeBase": "",
                "Piedini_TrattamentoSuperficialeDado": "",
                "Piedini_TrattamentoSuperficialePerno": "",
                "Pomelli_Colore": "",
                "Pomelli_ColoreImpugnatura": "",
                "Pomelli_ColoreTappo": "",
                "Pomelli_Finitura": "",
                "Pomelli_FinituraImpugnatura": "",
                "Pomelli_Materiale": "",
                "Pomelli_MaterialeBoccola": "Material bushing",
                "Pomelli_MaterialeImpugnatura": "Material grip",
                "Pomelli_MaterialePerno": "Material pin",
                "Pomelli_MaterialeSpina": "Material pin",
                "Pomelli_Note": "Notes",
                "Pomelli_TrattamentoSuperficialeBoccola": "",
                "Pomelli_TrattamentoSuperficialePerno": "",
                "Pressacavi_Accessori": "",
                "Pressacavi_AnelloTenuta": "Material sealing ring",
                "Pressacavi_AnelloTenutaEsterno": "Material external sealing ring",
                "Pressacavi_AnelloTenutaInterno": "Material internal sealing ring",
                "Pressacavi_Autoestinguenza": "Self-extinguishing",
                "Pressacavi_Certificazione": "Certification",
                "Pressacavi_Colore": "",
                "Pressacavi_Corpo": "",
                "Pressacavi_GradoProtezione": "Protection grade",
                "Pressacavi_Guarnizione": "",
                "Pressacavi_Impiego": "Use",
                "Pressacavi_Inserto": "Material insert",
                "Pressacavi_Materiale": "Material",
                "Pressacavi_MaterialeCorpo": "Material body",
                "Pressacavi_MaterialeGuarnizione": "Material gasket",
                "Pressacavi_MaterialeOring": "Material O-ring",
                "Pressacavi_Membrana": "Material diaphragm",
                "Pressacavi_Molla": "Material spring",
                "Pressacavi_Note": "Notes",
                "Pressacavi_Oring": "",
                "Pressacavi_PassaggioAcqua": "Water passage",
                "Pressacavi_PassaggioAria": "Air passage",
                "Pressacavi_TemperaturaEsercizio": "Operating temperature",
                "Pressacavi_TestStandard": "Standard test",
                "Pressacavi_TrattamentoSuperficiale": "",
                "Pressacavi_TrattamentoSuperficialeCorpo": "",
                "Pressacavi_UlCsaFile": "Ul/Csa-File",
                "Ruote_Accessori": "Accessories",
                "Ruote_Impiego": "Use",
                "Ruote_Materiale": "",
                "Ruote_MaterialeAnello": "Material ring",
                "Ruote_MaterialeNucleo": "Material cor",
                "Ruote_MaterialeParafilo": "Material thread-guard",
                "Ruote_MaterialeRuota": "Material heel",
                "Ruote_MaterialeSupporto": "Material support",
                "Ruote_Mozzo": "Hub",
                "Ruote_Note": "Notes",
                "Ruote_TempEsercizio": "Operating temperature",
                "Ruote_VelocitaLavoro": "Working speed",
                "Sollevamento_Attenzione": "",
                "Sollevamento_Certificazioni": "Certification",
                "Sollevamento_CoefficenteSicurezza": "Safety factor",
                "Sollevamento_Finitura": "",
                "Sollevamento_Impiego": "Use",
                "Sollevamento_Materiale": "Material",
                "Sollevamento_MaterialeCorpo": "Material body",
                "Sollevamento_MaterialeVite": "Material screw",
                "Sollevamento_Norma": "Standard",
                "Sollevamento_Note": "Notes",
                "Sollevamento_Orientabilita": "Adjustability",
                "Sollevamento_TempEsercizio": "Operating temperature",
                "Sollevamento_Test": "Test",
                "step": "Thread",
                "TappiPlastica_Colore": "Color",
                "TappiPlastica_Materiale": "Material",
                "TappiPlastica_MaterialeCorpo": "Material body",
                "TappiPlastica_MaterialeDadi": "Nut material",
                "TappiPlastica_MaterialeOring": "Material O-ring",
                "TappiPlastica_Note": "Notes",
                "TappiPlastica_TempEsercizio": "Operating temperature",
                "TerminaliElettrici_Accessori": "Accessories",
                "TerminaliElettrici_Autoestinguenza": "Self-extinguishing",
                "TerminaliElettrici_Corpo": "Material body",
                "TerminaliElettrici_Impiego": "Use",
                "TerminaliElettrici_Isolamento": "Insulation",
                "TerminaliElettrici_Materiale": "Material",
                "TerminaliElettrici_Morsetto": "Material cage insert",
                "TerminaliElettrici_Note": "Notes",
                "TerminaliElettrici_ProfiloCrimpatura": "Crimping profile",
                "TerminaliElettrici_TempEsercizio": "Operating temperature",
                "TerminaliElettrici_TensioneNominale": "Nominal voltage",
                "TerminaliElettrici_UlCsaFile": "Ul/Csa-File",
                "TerminaliElettrici_Vite": "Material screw",
                "uni": "UNI",
                "materialScrewClass": "Screw Material / Grade",
                "materialNutClass": "Nut Material / Grade",
                "washerHardness": "Washer hardness"
            }
        },
        "password_page": {
            "login_form_heading": "Enter store using password:",
            "login_password_button": "Enter using password",
            "login_form_password_label": "Password",
            "login_form_password_placeholder": "Your password",
            "login_form_error": "Wrong password!",
            "login_form_submit": "Enter",
            "admin_link_html": "Are you the store owner? <a href=\"/admin\" class=\"link underlined-link\">Log in here</a>",
            "powered_by_shopify_html": "This shop will be powered by {{ shopify }}"
        },
        "social": {
            "alt_text": {
                "share_on_facebook": "Share on Facebook",
                "share_on_twitter": "Tweet on Twitter",
                "share_on_pinterest": "Pin on Pinterest"
            },
            "links": {
                "twitter": "Twitter",
                "facebook": "Facebook",
                "linkedin": "Linkedin",
                "pinterest": "Pinterest",
                "instagram": "Instagram",
                "tumblr": "Tumblr",
                "snapchat": "Snapchat",
                "youtube": "YouTube",
                "vimeo": "Vimeo",
                "tiktok": "TikTok"
            }
        },
        "continue_shopping": "Continue shopping",
        "pagination": {
            "label": "Pagination",
            "page": "Page {{ number }}",
            "next": "Next page",
            "previous": "Previous page"
        },
        "br-pagination": {
            "label": "BR Pagination",
            "page": "Page {{ number }}",
            "next": "Next page",
            "previous": "Previous page"
        },
        "search": {
            "search": "Search",
            "search_code": "Search for article code...",
            "search_generic": "Search...",
            "custom_search_title": "Search",
            "reset": "Clear search term",
            "art_code": "Item code",
            "art_name": "Item name"
        },
        "cart": {
            "view": "View cart ({{ count }})",
            "view_empty_cart": "View cart",
            "item_added": "Item added to your cart"
        },
        "share": {
            "close": "Close share",
            "copy_to_clipboard": "Copy link",
            "share_url": "Link",
            "success_message": "Link copied to clipboard"
        },
        "slider": {
            "of": "of",
            "next_slide": "Slide right",
            "previous_slide": "Slide left",
            "name": "Slider"
        }
    },
    "newsletter": {
        "label": "Email",
        "success": "Thanks for subscribing",
        "button_label": "Subscribe"
    },
    "accessibility": {
        "skip_to_text": "Skip to content",
        "skip_to_product_info": "Skip to product information",
        "close": "Close",
        "unit_price_separator": "per",
        "vendor": "Vendor:",
        "error": "Error",
        "refresh_page": "Choosing a selection results in a full page refresh.",
        "link_messages": {
            "new_window": "Opens in a new window.",
            "external": "Opens external website."
        },
        "loading": "Loading...",
        "total_reviews": "total reviews",
        "star_reviews_info": "{{ rating_value }} out of {{ rating_max }} stars",
        "collapsible_content_title": "Collapsible content",
        "complementary_products": "Complementary products"
    },
    "blogs": {
        "article": {
            "blog": "Blog",
            "read_more_title": "Read more: {{ title }}",
            "comments": {
                "one": "{{ count }} comment",
                "other": "{{ count }} comments",
                "many": "{{ count }} comments"
            },
            "moderated": "Please note, comments need to be approved before they are published.",
            "comment_form_title": "Leave a comment",
            "name": "Name",
            "email": "Email",
            "message": "Comment",
            "post": "Post comment",
            "back_to_blog": "Back to blog",
            "share": "Share this article",
            "success": "Your comment was posted successfully! Thank you!",
            "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated."
        }
    },
    "onboarding": {
        "product_title": "Example product title",
        "collection_title": "Your collection's name"
    },
    "products": {
        "product": {
            "add_to_cart": "Add to cart",
            "additional_tab": "Additional Informations",
            "all_variants": "All variants",
            "certifications": "Certifications",
            "choose_options": "Choose options",
            "choose_product_options": "Choose options for {{ product_name }}",
            "compliance_sheet_download": "Download conformity sheet",
            "description": "Description",
            "in_the_cart": "In the cart, you can order the selected items or request a quote.",
            "inventory_in_stock_show_count": "{{ quantity }} in stock",
            "inventory_in_stock": "In stock",
            "inventory_low_stock_show_count": "Low stock: {{ quantity }} left",
            "inventory_low_stock": "Low stock",
            "inventory_out_of_stock_continue_selling": "In stock",
            "inventory_out_of_stock": "Out of stock",
            "life_cycle": "Life Cycle",
            "login_to_quote_html": "<a href='/en/account/login'>Log in</a> to your reserved area or register to request a quote.",
            "login_to_see_prices": "Log in to see prices.",
            "on_sale": "Sale",
            "product_variants": "Product variants",
            "regulations": "Regulations",
            "sign_up_to_buy_html": "<a href='/en/account/register'>Sign up</a>, fill the cart, and request a quote. We will initiate the affiliation process.",
            "sku": "SKU",
            "tech_sheet_download": "Download technical sheet",
            "variants_title": "Article variants",
            "variants_subtitle": "view the cart to order or request a new quote.",
            "want_to_be_customer": "Would you like to become our customer?",
            "want_to_quote": "Do you want to place an order or request a quote?",
            "media": {
                "gallery_viewer": "Gallery Viewer",
                "load_image": "Load image {{ index }} in gallery view",
                "load_model": "Load 3D Model {{ index }} in gallery view",
                "load_video": "Play video {{ index }} in gallery view",
                "image_available": "Image {{ index }} is now available in gallery view",
                "open_media": "Open media {{ index }} in modal",
                "play_model": "Play 3D Viewer",
                "play_video": "Play video"
            },
            "quantity": {
                "label": "Quantity",
                "input_label": "Quantity for {{ product }}",
                "increase": "Increase quantity for {{ product }}",
                "decrease": "Decrease quantity for {{ product }}",
                "minimum_of": "Minimum of {{ quantity }}",
                "maximum_of": "Maximum of {{ quantity }}",
                "multiples_of": "Increments of {{ quantity }}",
                "in_cart_html": "<span class=\"quantity-cart\">{{ quantity }}</span> in cart",
                "note": "View quantity rules"
            },
            "volume_pricing": {
                "title": "Volume Pricing",
                "note": "Volume pricing available",
                "minimum": "{{ quantity }}+",
                "price_at_each": "at {{ price }}/ea",
                "price_range": "{{ minimum }} - {{ maximum }}"
            },
            "pickup_availability": {
                "view_store_info": "View store information",
                "check_other_stores": "Check availability at other stores",
                "pick_up_available": "Pickup available",
                "pick_up_available_at_html": "Pickup available at <span class=\"color-foreground\">{{ location_name }}</span>",
                "pick_up_unavailable_at_html": "Pickup currently unavailable at <span class=\"color-foreground\">{{ location_name }}</span>",
                "unavailable": "Couldn't load pickup availability",
                "refresh": "Refresh"
            },
            "price": {
                "from_price_html": "From {{ price }}",
                "regular_price": "Regular price",
                "sale_price": "Sale price",
                "unit_price": "Unit price"
            },
            "share": "Share this product",
            "sold_out": "Sold out",
            "unavailable": "Unavailable",
            "vendor": "Vendor",
            "value_unavailable": "{{ option_value }} - Unavailable",
            "variant_sold_out_or_unavailable": "Variant sold out or unavailable",
            "video_exit_message": "{{ title }} opens full screen video in same window.",
            "view_full_details": "View full details",
            "xr_button": "View in your space",
            "xr_button_label": "View in your space, loads item in augmented reality window",
            "include_taxes": "Tax included.",
            "shipping_policy_html": "<a href=\"{{ link }}\">Shipping</a> calculated at checkout.",
            "additional_infos": {
                "ElemPosiz_Colore": "Color",
                "ElemPosiz_InsertoLongLok": "Long Lok Insert"
            }
        },
        "modal": {
            "label": "Media gallery"
        },
        "facets": {
            "filter_and_operator_subtitle": "Match all",
            "apply": "Apply",
            "clear": "Clear",
            "clear_all": "Remove all",
            "from": "From",
            "filter_and_sort": "Filter and sort",
            "filter_by_label": "Filter:",
            "filter_button": "Filter",
            "filters_selected": {
                "one": "{{ count }} selected",
                "other": "{{ count }} selected",
                "many": "{{ count }} selected"
            },
            "filter_selected_accessibility": "{{ type }} ({{ count }} filters selected)",
            "show_more": "Show more",
            "show_less": "Show less",
            "max_price": "The highest price is {{ price }}",
            "product_count": {
                "one": "{{ product_count }} of {{ count }} product",
                "other": "{{ product_count }} of {{ count }} products",
                "many": "{{ product_count }} on {{ count }} products"
            },
            "product_count_simple": {
                "one": "{{ count }} product",
                "other": "{{ count }} products",
                "many": "{{ count }} products"
            },
            "reset": "Reset",
            "sort_button": "Sort",
            "sort_by_label": "Sort by:",
            "to": "To",
            "clear_filter": "Remove filter"
        }
    },
    "templates": {
        "search": {
            "no_results": "No results found for “{{ terms }}”. Check the spelling or use a different word or phrase.",
            "page": "Page",
            "products": "Products",
            "results_pages_with_count": {
                "one": "{{ count }} page",
                "other": "{{ count }} pages",
                "many": "{{ count }} pages"
            },
            "results_suggestions_with_count": {
                "one": "{{ count }} suggestion",
                "other": "{{ count }} suggestions",
                "many": "{{ count }} suggestions"
            },
            "results_products_with_count": {
                "one": "{{ count }} product",
                "other": "{{ count }} products",
                "many": "{{ count }} products"
            },
            "results_with_count": {
                "one": "{{ count }} result",
                "other": "{{ count }} results",
                "many": "{{ count }} results"
            },
            "results_with_count_and_term": {
                "one": "{{ count }} result found for “{{ terms }}”",
                "other": "{{ count }} results found for “{{ terms }}”",
                "many": "{{ count }} results found for \" {{ terms }} \""
            },
            "title": "Search results",
            "search_for": "Search for “{{ terms }}”",
            "suggestions": "Suggestions",
            "pages": "Pages"
        },
        "cart": {
            "cart": "Cart"
        },
        "contact": {
            "form": {
                "title": "Contact form",
                "name": "Name",
                "email": "Email",
                "phone": "Phone number",
                "comment": "Comment",
                "send": "Send",
                "post_success": "Thanks for contacting us. We'll get back to you as soon as possible.",
                "error_heading": "Please adjust the following:"
            }
        },
        "work_with_us": {
            "form": {
                "first_name": "First name",
                "last_name": "Last name",
                "email": "Email",
                "phone": "Phone number",
                "presentation": "Presentation",
                "terms": {
                    "name": "terms",
                    "first_text": "Per le finalità indicate in relazione all’",
                    "link_text": "informativa che mi avete fornito",
                    "last_text": ", esprimo il consenso al trattamento dei miei dati personali da parte della vostra Azienda."
                },
                "cv": {
                    "label": "Carica il tuo CV",
                    "select_file": "Seleziona file",
                    "no_files_uploaded": "Nessun file caricato",
                    "upload": "Carica",
                    "name": "CV file"
                },
                "send": "Send Application",
                "comment": "EVERYTHING"
            }
        },
        "404": {
            "title": "Page not found",
            "subtext": "404"
        }
    },
    "sections": {
        "announcements": {
            "previous_announcement": "Previous announcement",
            "next_announcement": "Next announcement",
            "carousel": "Carousel",
            "announcement": "Announcement",
            "announcement_bar": "Announcement bar"
        },
        "header": {
            "announcement": "Announcement",
            "menu": "Menu",
            "cart_count": {
                "one": "{{ count }} item",
                "other": "{{ count }} items",
                "many": "{{ count }} articles"
            }
        },
        "cart": {
            "title": "Your cart",
            "caption": "Cart items",
            "remove_title": "Remove {{ title }}",
            "estimated_total": "Estimated total",
            "new_estimated_total": "New estimated total",
            "note": "Order special instructions",
            "checkout": "Check out",
            "empty": "Your cart is empty",
            "cart_error": "There was an error while updating your cart. Please try again.",
            "cart_quantity_error_html": "You can only add {{ quantity }} of this item to your cart.",
            "taxes_and_shipping_policy_at_checkout_html": "Taxes, Discounts and <a href=\"{{ link }}\">shipping</a> calculated at checkout",
            "taxes_included_but_shipping_at_checkout": "Tax included and shipping and discounts calculated at checkout",
            "taxes_included_and_shipping_policy_html": "Tax included. <a href=\"{{ link }}\">Shipping</a> and discounts calculated at checkout.",
            "taxes_and_shipping_at_checkout": "Taxes, discounts and shipping calculated at checkout",
            "headings": {
                "product": "Product",
                "price": "Price",
                "total": "Total",
                "quantity": "Quantity",
                "image": "Product image"
            },
            "update": "Update",
            "login": {
                "title": "Have an account?",
                "paragraph_html": "<a href=\"{{ link }}\" class=\"link underlined-link\">Log in</a> to check out faster."
            }
        },
        "footer": {
            "payment": "Payment methods"
        },
        "featured_blog": {
            "view_all": "View all",
            "onboarding_title": "Blog post",
            "onboarding_content": "Give your customers a summary of your blog post"
        },
        "featured_collection": {
            "view_all": "View all",
            "view_all_label": "View all products in the {{ collection_name }} collection"
        },
        "collection_list": {
            "view_all": "View all"
        },
        "collection_template": {
            "empty": "No products found",
            "title": "Collection",
            "use_fewer_filters_html": "Use fewer filters or <a class=\"{{ class }}\" href=\"{{ link }}\">remove all</a>"
        },
        "video": {
            "load_video": "Load video: {{ description }}"
        },
        "slideshow": {
            "load_slide": "Load slide",
            "previous_slideshow": "Previous slide",
            "next_slideshow": "Next slide",
            "pause_slideshow": "Pause slideshow",
            "play_slideshow": "Play slideshow",
            "carousel": "Carousel",
            "slide": "Slide"
        },
        "page": {
            "title": "Page title"
        },
        "quick_order_list": {
            "product_total": "Product subtotal",
            "view_cart": "View cart",
            "each": "{{ money }}/ea",
            "product": "Product",
            "variant": "Variant",
            "variant_total": "Variant total",
            "items_added": {
                "one": "{{ quantity }} item added",
                "other": "{{ quantity }} items added",
                "many": "{{ quantity }} items added"
            },
            "items_removed": {
                "one": "{{ quantity }} item removed",
                "other": "{{ quantity }} items removed",
                "many": "{{ quantity }} items removed"
            },
            "product_variants": "Product variants",
            "total_items": "Total items",
            "remove_all_items_confirmation": "Remove all {{ quantity }} items from your cart?",
            "remove_all": "Remove all",
            "cancel": "Cancel"
        }
    },
    "localization": {
        "country_label": "Country/region",
        "language_label": "Language",
        "update_language": "Update language",
        "update_country": "Update country/region"
    },
    "customer": {
        "account": {
            "title": "Account",
            "details": "Account details",
            "view_addresses": "View addresses",
            "return": "Return to Account details"
        },
        "account_fallback": "Account",
        "activate_account": {
            "title": "Activate account",
            "subtext": "Create your password to activate your account.",
            "password": "Password",
            "password_confirm": "Confirm password",
            "submit": "Activate account",
            "cancel": "Decline invitation"
        },
        "addresses": {
            "title": "Addresses",
            "default": "Default",
            "add_new": "Add a new address",
            "edit_address": "Edit address",
            "first_name": "First name",
            "last_name": "Last name",
            "company": "Company",
            "address1": "Address 1",
            "address2": "Address 2",
            "city": "City",
            "country": "Country/region",
            "province": "Province",
            "zip": "Postal/ZIP code",
            "phone": "Phone",
            "set_default": "Set as default address",
            "add": "Add address",
            "update": "Update address",
            "cancel": "Cancel",
            "edit": "Edit",
            "delete": "Delete",
            "delete_confirm": "Are you sure you wish to delete this address?"
        },
        "log_in": "Log in",
        "log_out": "Log out",
        "login_page": {
            "cancel": "Cancel",
            "create_account": "Create account",
            "email": "Email",
            "forgot_password": "Forgot your password?",
            "guest_continue": "Continue",
            "guest_title": "Continue as a guest",
            "password": "Password",
            "title": "Login",
            "sign_in": "Sign in",
            "submit": "Submit",
            "send_edit_password_title": "Send edit request",
            "send_edit_password_subtitle": "We'll send you an email with the edit link"
        },
        "order": {
            "title": "Order {{ name }}",
            "date_html": "Placed on {{ date }}",
            "cancelled_html": "Order Cancelled on {{ date }}",
            "cancelled_reason": "Reason: {{ reason }}",
            "billing_address": "Billing Address",
            "payment_status": "Payment Status",
            "shipping_address": "Shipping Address",
            "fulfillment_status": "Fulfillment Status",
            "discount": "Discount",
            "shipping": "Shipping",
            "tax": "Tax",
            "product": "Product",
            "sku": "SKU",
            "price": "Price",
            "quantity": "Quantity",
            "total": "Total",
            "total_refunded": "Refunded",
            "fulfilled_at_html": "Fulfilled {{ date }}",
            "track_shipment": "Track shipment",
            "tracking_url": "Tracking link",
            "tracking_company": "Carrier",
            "tracking_number": "Tracking number",
            "subtotal": "Subtotal",
            "total_duties": "Duties"
        },
        "orders": {
            "title": "Order history",
            "order_number": "Order",
            "order_number_link": "Order number {{ number }}",
            "date": "Date",
            "payment_status": "Payment status",
            "fulfillment_status": "Fulfillment status",
            "total": "Total",
            "none": "You haven't placed any orders yet."
        },
        "recover_password": {
            "title": "Reset your password",
            "subtext": "We will send you an email to reset your password",
            "success": "We've sent you an email with a link to update your password."
        },
        "register": {
            "title": "Register to become a customer",
            "subtitle": "Registrati per accedere alla tua area riservata. Potrai avere accesso al listino prezzi dei nostri prodotti, effettuare gli ordini e richiedere preventivi per il tuo punto vendita.",
            "has_account": "Hai già un account?",
            "login": "Accedi",
            "submit": "Create",
            "create_account": {
                "title": "Create account",
                "email": "Email address",
                "password": "Password",
                "password_confirm": "Password confirm"
            },
            "personal_info": {
                "title": "Personal info",
                "first_name": "First name",
                "last_name": "Last name",
                "role": "Role",
                "phone": "Phone"
            },
            "company": {
                "title": "Company",
                "company_name": "Company name",
                "vat_number": "Vat number",
                "business_sector": "Business sector",
                "employees_number": "Employees number",
                "phone": "Phone",
                "address": "Address",
                "civic_address": "Civic address",
                "nation": "Nation",
                "province": "Province",
                "postal_code": "Postal code",
                "city": "City"
            }
        },
        "reset_password": {
            "title": "Reset account password",
            "subtext": "Enter a new password",
            "password": "Password",
            "password_confirm": "Confirm password",
            "submit": "Reset password"
        }
    },
    "gift_cards": {
        "issued": {
            "how_to_use_gift_card": "Use the gift card code online or QR code in-store",
            "title": "Here's your {{ value }} gift card balance for {{ shop }}!",
            "subtext": "Your gift card",
            "gift_card_code": "Gift card code",
            "shop_link": "Visit online store",
            "add_to_apple_wallet": "Add to Apple Wallet",
            "qr_image_alt": "QR code — scan to redeem gift card",
            "copy_code": "Copy gift card code",
            "expiration_date": "Expires {{ expires_on }}",
            "copy_code_success": "Code copied successfully",
            "expired": "Expired"
        }
    },
    "recipient": {
        "form": {
            "checkbox": "I want to send this as a gift",
            "expanded": "Gift card recipient form expanded",
            "collapsed": "Gift card recipient form collapsed",
            "email_label": "Recipient email",
            "email_label_optional_for_no_js_behavior": "Recipient email (optional)",
            "email": "Email",
            "name_label": "Recipient name (optional)",
            "name": "Name",
            "message_label": "Message (optional)",
            "message": "Message",
            "max_characters": "{{ max_chars }} characters max",
            "send_on": "YYYY-MM-DD",
            "send_on_label": "Send on (optional)"
        }
    },
    "select_customer": {
        "customer": "Customer",
        "select_customer": "Select customer or Customer group",
        "search_customer": "Search customer by code, customer name or group...",
        "code": "Code",
        "name": "Name",
        "customerGroup": "Customer group"
    },
    "berardi": {
        "go_back": "Go back",
        "csv_importing": "Sto importando il CSV selezionato.",
        "no_close_advice": "Non chiudere o ricaricare questa pagina.",
        "error_csv_importing": "Si è verificato un errore durante il caricamento del CSV.",
        "success_full_csv_importing": "Import del CSV avvenuto con successo.",
        "success_partial_csv_importing": "L'import del CSV è avvenuto con successo, ma sono presenti errori.",
        "reorder_progress": "Sto aggiungendo al carrello i prodotti dell'ordine selezionato.",
        "error_reorder": "Si è verificato un errore durante l'aggiunta al carrello.",
        "success_full_reorder": "Aggiunta al carrello avvenuta con successo.",
        "success_partial_reorder": "L'aggiunta al carrello è avvenuta con successo, ma sono presenti errori.",
        "send_order_quote_progress": "Sto creando l'ordine e/o il preventivo.",
        "error_send_order_quote": "Si è verificato un errore durante la creazione dell'ordine e/o il preventivo.",
        "account": {
            "menu": {
                "general_infos": "General information",
                "company": "Company",
                "orders_history": "Orders history",
                "quotes_history": "Offers history",
                "invoices_history": "Invoices history",
                "logout": "Logout"
            },
            "general_infos": {
                "title": "General information",
                "account_infos": "Account information",
                "user_name": "Username",
                "user_email": "E-mail",
                "user_role": "Role",
                "user_mobile": "Mobile nr.",
                "change_password": "Change password",
                "agency_infos": "Company information",
                "customer_code": "Customer code",
                "company": "Company name",
                "vat": "VAT number",
                "activity": "Business sector",
                "workers": "Employees",
                "phone": "Phone nr.",
                "country": "Country",
                "province": "State/County",
                "city": "City",
                "zip": "ZIP code",
                "address": "Address"
            },
            "company": {
                "title": "Company information",
                "company": "Company name",
                "customer_code": "Customer code",
                "name": "Name",
                "vat": "VAT number",
                "business": "Business sector",
                "workers": "Employees",
                "phone": "Phone nr.",
                "country": "Country",
                "province": "State/County",
                "city": "City",
                "zip": "ZIP code",
                "address": "Address",
                "operational_users": "Authorized operators",
                "table": {
                    "user_name": "Username",
                    "email": "Email",
                    "phone": "Mobile nr."
                },
                "no_companies_found": "No companies found"
            },
            "orders_history": {
                "title": "Orders history",
                "label_select_company": "View orders:",
                "doc_number": "Document number",
                "doc_number_placeholder": "ex. 0046100300300",
                "from": "from",
                "to": "to",
                "search_order": "Order search",
                "nothing_found": "No orders found",
                "error_reorder": "An error occurred.",
                "table": {
                    "order": "Order",
                    "date": "Date",
                    "total": "Total amount",
                    "order_status": "Order status",
                    "reorder": "Reorder",
                    "load_more": "Load more orders"
                }
            },
            "quotes_history": {
                "title": "Quotations history",
                "label_select_company": "View quotations:",
                "doc_number": "Document number",
                "doc_number_placeholder": "ex. 0046100300300",
                "from": "from",
                "to": "to",
                "search_quote": "Search quotation",
                "nothing_found": "No quotations found",
                "table": {
                    "quote": "Quotation",
                    "date": "Date",
                    "new_offer": "New quotation",
                    "quote_status": "Quotation status",
                    "load_more": "Load more quotations"
                }
            },
            "invoices_history": {
                "title": "Invoices history",
                "label_select_company": "View payments status:",
                "expired_invoices": "Expired invoices",
                "expiring_invoices": "Expiring invoices",
                "payment_method": "Payment method",
                "billing_address": "Billing address",
                "nothing_found": "No invoice found",
                "table": {
                    "invoice_number": "Invoice number",
                    "date": "Invoice date",
                    "expiring_date": "Expiry date",
                    "payment_method": "Payment method",
                    "value": "Due amount",
                    "invoice_status": "Invoice status",
                    "currency": "Currency",
                    "download": "Download",
                    "load_more": "Load more invoices",
                    "error_download": "Error during invoice download"
                }
            },
            "order_detail": {
                "title": "Order",
                "go_back": "Back",
                "download": "Download",
                "your_reference": "Your order nr.",
                "date_order": "Order date",
                "weight": "Weight (Kgs)",
                "payment": "Payment terms",
                "return_terms": "Delivery terms",
                "billing_address": "Billing address",
                "shipping_address": "Shipping address",
                "table": {
                    "art_code": "Product code",
                    "art_code_customer": "Customer product code",
                    "description": "Description",
                    "measure_unit": "UM",
                    "total_quantity": "Total quantity",
                    "unit_price": "Unit price",
                    "discount_1": "Discount 1",
                    "discount_2": "Discount 2",
                    "discount_3": "Discount 3",
                    "increase": "Increase",
                    "net_unit_price": "Net price",
                    "net_total": "Net amount",
                    "deliver_date": "Delivery date"
                }
            },
            "quote_detail": {
                "title": "Quotation",
                "go_back": "Back",
                "download": "Download",
                "your_reference": "Your reference",
                "date_quote": "Quotation date",
                "weight": "Weight (Kgs)",
                "payment": "Payment terms",
                "return_terms": "Delivery terms",
                "billing_address": "Billing address",
                "shipping_address": "Shipping address",
                "table": {
                    "art_code": "Product code",
                    "art_code_customer": "Customer product code",
                    "description": "Description",
                    "measure_unit": "UM",
                    "total_quantity": "Total quantity",
                    "unit_price": "Unit price",
                    "discount_1": "Discount 1",
                    "discount_2": "Discount 2",
                    "discount_3": "Discount 3",
                    "increase": "Increase",
                    "net_unit_price": "Net price",
                    "net_total": "Net amount",
                    "deliver_date": "Delivery date"
                }
            },
            "document_status_list": {
                "pending": "pending",
                "delivering": "delivering",
                "delivered": "delivered",
                "processed": "shipped",
                "invoiced": "invoices",
                "refused": "declined",
                "accepted": "accepted",
                "on_customer_approve": "pending customer approval",
                "on_offer_progress": "quotation pending",
                "canceled": "canceled",
                "expired": "expired",
                "expiring": "expiring",
                "paid": "paid",
                "active": "active",
                "created": "created",
                "approved": "approved",
                "cancelled": "canceled",
                "confirmed": "confirmed"
            },
            "totals_component": {
                "text": "The General conditions of supply available on www.gberardi.com apply to all sales contracts by BERARDI BULLONERIE s.r.l.. Differing contractual conditions, even if contained in the customer's general or special conditions of purchase, shall be inapplicable and shall not bind BERARDI BULLONERIE s.r.l. unless the latter expressly accepts them in writing.",
                "products_total": "Total products",
                "discount": "Discount",
                "net_total": "Net amount",
                "packaging": "Packaging/other charges",
                "shipment": "Freight cost",
                "order_total": "Total order amount"
            }
        },
        "cart": {
            "cart_title": "My shopping cart",
            "login_to_receive_quotation": "Log in or sign up to request a quotation.",
            "proceed_to_checkout": "Proceed to checkout.",
            "minimum_order_total": "Minimum order amount is 200,00€",
            "code": "Product code",
            "details": "details",
            "request_quotation": "Request quotation",
            "request_quotation_text": "Send a request for the item in your shopping cart. Our customer service will contact you with a personalized offer.",
            "quote_all": "Request quotation for all items",
            "quote": "quotation",
            "order_detail": "Order detail",
            "total_items": "Total products",
            "subtotal": "Subtotal",
            "quantity_discount": "Quantity discount",
            "total_no_vat": "Amount excl. VAT",
            "vat": "VAT",
            "total": "Amount incl. VAT",
            "quote_request": "Quotation request",
            "pieces": "Pieces",
            "pieces_short": "pcs",
            "quote_request_text": "The subtotal is provisional. The quotation may change in case of high quantities.",
            "proceed": "Proceed",
            "csv_box_title": "Do you want to load the shopping cart from your product list?",
            "csv_box_text": "Load your .csv file with the desired product codes and quantities.",
            "csv_box_text_instructions": "If your item code is registered in our system, please insert it under the column CUSTOMER_CODE",
            "csv_box_no_file": "No .csv loaded",
            "csv_select_file": "Select file",
            "csv_download": "Download template",
            "csv_upload": "Upload",
            "unit_price": "Unit price",
            "error_uploading_csv": "Errore uploading CSV file",
            "summary": {
                "title": "Summary",
                "subtitle": "Send your request to our customer service. You can check the status of your requests in your customer area.",
                "order_summary": "Order summary",
                "addresses": "Addresses",
                "billing_address": "Billing address",
                "shipping_address": "Shipping address",
                "additional_info": "Additional information",
                "your_reference": "Your reference",
                "input_reference": "Insert reference",
                "note": "Notes",
                "input_note": "Insert note",
                "order_items": "Ordered products",
                "items_total": "Items total",
                "discount": "Discount",
                "order_total": "Order total",
                "order_total_quote": "Quotation request",
                "quote_summary": "Quotation summary",
                "input_note_quote": "Add notes to quotation",
                "quote_items": "Quoted products",
                "disclaimer": "The General conditions of supply available on www.gberardi.com apply to all sales contracts by BERARDI BULLONERIE s.r.l.. Differing contractual conditions, even if contained in the customer's general or special conditions of purchase, shall be inapplicable and shall not bind BERARDI BULLONERIE s.r.l. unless the latter expressly accepts them in writing.",
                "send": "Send",
                "error_send_order_quote": "An error occurred during order transmission"
            },
            "thank_you": {
                "thank_you_title": "Thank you for choosing us!",
                "for_more_info": "We have received your request. You can check the status of your requests in your customer area.",
                "back_to_home": "Back to home",
                "order_title": "Order",
                "order_title_failed": "Order sent",
                "order_not_success": "Your order has to be checked by one of our operators. As soon as it is verified, you will find it in your Orders History",
                "order_success": "The order was sent correctly. You will soon be able to monitor the order status in your customer area.",
                "items_number": "Number of products",
                "quote_title": "Quotation request sent",
                "quote_success": "You will receive our quotation from one of our operators over the next hours",
                "quote_not_success": "Your quotation has to be checked by one of our operators. You will receive it as soon as possible."
            }
        },
        "product": {
            "buttons": {
                "tech_sheet_download": "Download data sheet",
                "compliance_sheet_download": "Download compliance sheet"
            },
            "table_data": {
                "code": "Code",
                "color": "Color",
                "brand": "Brand",
                "material": "Material"
            },
            "filters": {
                "sku": "Product Code"
            },
            "table": {
                "art_code": "Item Code",
                "art_code_customer": "Cust. Item Code",
                "weight": "Weight",
                "pieces_per_package": "Pcs/box",
                "unit_price": "Unit price",
                "total_price": "Total amount",
                "number_of_pieces": "Nr. of pieces",
                "availability": "Availability",
                "associate": "Associate",
                "login_to_see_price": "Log in to view price",
                "pieces": "Pieces",
                "details": "details",
                "insufficient_qty": "Partial q.ty available",
                "not_available": "Not available",
                "available": "In stock",
                "load_more_variants": "Load other variants",
                "added_product": "Product added to cart: ",
                "filter_label": "Filter by",
                "carico_max_dan": "Max load (daN)",
                "diam_albero": "Ø shaft",
                "portata_in_kg": "Max load (kg)",
                "dndeg_fil_x_pollice": "d/TPI x inch"
            },
            "clothing_selector": {
                "add_to_cart": "Add to cart",
                "color": "Color",
                "size": "Size",
                "unit_price": "Unit price",
                "pieces_number": "Nr. of pieces",
                "total_price": "Total amount",
                "insufficient_qty": "Partial q.ty available",
                "not_available": "Not available",
                "available": "In stock"
            }
        },
        "modals": {
            "general": {
                "confirm": "Confirm",
                "cancel": "Cancel"
            },
            "associate_id": {
                "title": "Customer product code",
                "paragraph": "Insert your product code to associate with our product code.",
                "customer_code": "Customer product code",
                "placeholder": "Insert customer product code",
                "warning_text": "Warning! You can modify this field only once!",
                "explanation_confirm": "Make sure your product code is correct and confirm association. After you have associated the code, you will not be able to change it further without assistance. To modify the customer product code further, please contact Berardi's customer service.",
                "associate_button": "Associate"
            }
        },
        "search": {
            "search_code": "Search code...",
            "cod_art": "Product code",
            "name_art": "Product name",
            "no_product_found": "No product found",
            "no_query": "Type into the search bar and press ENTER to view results"
        },
        "general": {
            "login": "Log in",
            "sign_up": "Sign up",
            "select": "Select"
        }
    },
    "shopify": {
        "checkout": {
            "general": {
                "map": {
                    "cluster_title": {
                        "many": "Grouping of {{number}} highlighters"
                    }
                }
            },
            "customer_account": {
                "saved_address_option_description": {
                    "many": "You have {{count}} saved addresses."
                }
            },
            "stock": {
                "unshippable_product": {
                    "header": {
                        "many": "No deliveries available for %{count} items"
                    },
                    "message": {
                        "many": "These items will be removed from your cart as there are no delivery methods available for your address."
                    }
                },
                "item_label": {
                    "many": "{{count}} articles"
                },
                "unfulfillable_product": {
                    "message": {
                        "many": "%{delivery_method} is no longer available for these items."
                    },
                    "default_message": {
                        "many": "The delivery method you selected is no longer available for these items."
                    }
                }
            },
            "order_summary": {
                "expand_component_information": {
                    "many": "Show %{count} items"
                },
                "collapse_component_information": {
                    "many": "Hide %{count} items"
                },
                "discount_discovery": {
                    "merchandise_quantity_label": {
                        "many": "%{count} articles"
                    }
                },
                "discount_title_stacking": {
                    "many": "Discounts"
                },
                "discount_order_stacking": {
                    "many": "Order Discounts"
                },
                "subtotal_label_with_quantity": {
                    "many": "Subtotal • %{count} items"
                },
                "number_items": {
                    "many": "%{count} articles"
                },
                "view_all_items": {
                    "many": "View all articles (%{count})"
                }
            },
            "shipping": {
                "estimated_delivery_date": {
                    "many": "%{count} working days"
                },
                "other_method": {
                    "many": "%{count} other methods available starting from"
                },
                "subscription_delivery_description": {
                    "prepaid_delivery_frequency": {
                        "many": "for %{count} deliveries"
                    },
                    "subscription_delivery_frequency": {
                        "day": {
                            "many": "every %{count} days"
                        },
                        "week": {
                            "many": "every %{count} weeks"
                        },
                        "month": {
                            "many": "every %{count} months"
                        },
                        "year": {
                            "many": "every %{count} years"
                        }
                    },
                    "first_n_order_free": {
                        "many": "First %{count} orders free"
                    },
                    "free_for_first_n_order": {
                        "many": "For the first %{count} orders"
                    },
                    "free_shipping_cycles": {
                        "many": "Free shipping for other %{count} deliveries"
                    },
                    "free_shipping_cycles_delivery_not_included": {
                        "many": "Free shipping for %{count} deliveries"
                    },
                    "first_n_order_free_with_cycle": {
                        "many": "Free shipping for another %{count} deliveries, then at the price of %{recurring_order_shipping_price}"
                    },
                    "first_n_order_free_with_cycle_delivery_not_included": {
                        "many": "Free shipping for %{count} deliveries, then at the price of %{recurring_order_shipping_price}"
                    },
                    "max_cycles_base_shipping": {
                        "many": "Other %{count} deliveries at %{shipping_price} each"
                    },
                    "max_cycles_base_shipping_delivery_not_included": {
                        "many": "Other %{count} deliveries at %{shipping_price} each"
                    },
                    "prepaid_free_shipping_with_cycles": {
                        "many": "Free shipping for the first %{cycle} period, after that at the price of %{recurring_order_shipping_price}"
                    },
                    "prepaid_order_one_cycle": {
                        "many": "%{shipping_price} for other %{count} deliveries (%{per_delivery_cost})"
                    },
                    "prepaid_order_one_cycle_delivery_not_included": {
                        "many": "%{shipping_price} per %{count} deliveries (%{per_delivery_cost})"
                    },
                    "prepaid_order_no_cycle": {
                        "many": "%{shipping_price} for other %{count} deliveries (%{per_delivery_cost}), following the price of %{recurring_order_shipping_price}"
                    },
                    "prepaid_order_no_cycle_delivery_not_included": {
                        "many": "%{shipping_price} for %{count} deliveries (%{per_delivery_cost}), following the price of %{recurring_order_shipping_price}"
                    }
                },
                "shipping_method_first_shipment_group_title": {
                    "many": "First shipments"
                },
                "shipping_method_recurring_shipments_group_title": {
                    "many": "Recurring shipments"
                }
            },
            "payment": {
                "order_covered_by_gift_cards_notice": {
                    "many": "Your order is covered by your gift cards."
                },
                "card_fields_unavailable_html": {
                    "many": "At this time, credit and debit card payments are not available.<br> <a href=\"%{current_url}\">Please refresh this page</a> or try another payment method."
                },
                "expired_cards_info": {
                    "many": "There are %{count} expired cards, which you can view and edit in your account."
                },
                "order_edit_banner_items_added": {
                    "many": "%{count} added"
                }
            },
            "shipping_errors": {
                "shipping_method_not_available_generic": {
                    "many": "Some items in your cart cannot be shipped to the address you entered. Please check the address to make sure it is correct and try again, or select a different address."
                },
                "shipping_method_not_available_updated": {
                    "many": "One or more items you added are not shipping to your location. Please remove them to check out or contact the store."
                }
            },
            "processing": {
                "wait": {
                    "medium": {
                        "many": "Your order is being processed. Estimated waiting time: %{count} minutes."
                    }
                }
            },
            "thank_you": {
                "login_reorder_link_text": {
                    "many": "buy these products too"
                },
                "gift_card_confirmation_by_text_typ": {
                    "many": "You will receive a text message with your gift cards in a few minutes."
                },
                "gift_card_confirmation_by_email_typ": {
                    "many": "You will receive an email with your gift cards in a few minutes."
                },
                "gift_card_email_title": {
                    "many": "Gift Cards Sent by Email"
                },
                "gift_card_text_title": {
                    "many": "Gift Cards Sent via SMS"
                },
                "gift_card_resent_confirmation": {
                    "many": "Gift cards have been resent."
                },
                "gift_card_resend_failure": {
                    "many": "There was a problem resending gift cards. Please try again or contact us."
                }
            },
            "order_payment_collection": {
                "changes_summary": {
                    "added": {
                        "many": "%{count} added"
                    }
                }
            },
            "open_graph_meta_tag": {
                "title_with_products": {
                    "many": "Buy %{product_name} and %{count} other items"
                }
            },
            "subscriptions": {
                "recurring_totals_with_policies": {
                    "first_cycles": {
                        "many": "First %{count} payments: %{total_price} each"
                    }
                },
                "recurring_total_intervals": {
                    "day": {
                        "many": "%{count} days"
                    },
                    "week": {
                        "many": "%{count} weeks"
                    },
                    "month": {
                        "many": "%{count} months"
                    },
                    "year": {
                        "many": "%{count} years"
                    }
                },
                "recurring_totals_with_initial_order_shipping_discount_with_policies": {
                    "first_cycles": {
                        "many": "subsequently %{count} payments, each at the price of %{total_price}"
                    }
                }
            },
            "contextual_availability": {
                "title": {
                    "many": "Products not available"
                },
                "products_not_available": {
                    "many": "These products will be removed from your cart as they are not available in your country/region."
                },
                "all_products_in_cart_unavailable": {
                    "many": "These products are not available in your country/region."
                }
            },
            "throttle": {
                "estimated_wait_time": {
                    "many": "Estimated waiting time: {{count}} minutes"
                }
            },
            "deliverability": {
                "not_deliverable": {
                    "title": {
                        "many": "No deliveries available for %{count} items"
                    },
                    "message": {
                        "many": "These items will be removed from your cart as there are no delivery methods available for your address."
                    }
                }
            },
            "pickup_point": {
                "paginator": {
                    "header": {
                        "many": "%{first} - %{last} of %{count} points displayed"
                    },
                    "selected_pickup_point_label": {
                        "many": "%{pickup_point_index} of %{count} points"
                    },
                    "selected_page": {
                        "many": "%{first} - %{last} of %{count} points"
                    }
                },
                "number_of_pickup_points_near_location": {
                    "many": "%{count} of collection points near you"
                }
            },
            "local_pickup": {
                "location_information": {
                    "many": "There are %{count} stores with available stock near %{address}"
                },
                "paginator": {
                    "label": {
                        "many": "%{first} - %{last} of %{count} stores"
                    }
                },
                "reveal_more_label": {
                    "many": "Show more %{count} locations"
                }
            }
        },
        "notices": {
            "order": {
                "cancel_reason": {
                    "many": "Other"
                }
            }
        },
        "page_titles": {
            "search_results": {
                "many": "Search: %{count} results found for \"%{terms}\""
            }
        }
    },
    "customer_accounts": {
        "orders": {
            "order_list": {
                "items": {
                    "many": "{{count}} articles"
                }
            },
            "order_status": {
                "delivered_description_gift_card": {
                    "many": "Gift cards sent via email."
                },
                "gift_card_label": {
                    "many": "Gift vouchers"
                },
                "gift_card_resend": {
                    "many": "Resend email"
                },
                "gift_card_resend_description": {
                    "many": "If they have not been received, please resend the emails or"
                },
                "confirmed_gift_card_additional_description": {
                    "many": "Each gift card will be sent in a separate email."
                },
                "delivered_description_gift_card_text": {
                    "many": "Gift cards were sent via message."
                },
                "gift_card_resend_text": {
                    "many": "Repeat sending messages"
                },
                "gift_card_resend_description_text": {
                    "many": "If they were not received, resend the messages or"
                },
                "confirmed_gift_card_additional_description_text": {
                    "many": "Each gift card will be sent in a separate message."
                },
                "gift_resend_success": {
                    "many": "Gift Cards Resent"
                },
                "gift_resend_failure": {
                    "many": "There was a problem resending gift cards. Please try again or contact us."
                },
                "delivered_description_digital": {
                    "many": "These articles have been completed."
                }
            },
            "if_not_received": {
                "many": "If they have not been received,"
            }
        },
        "order_details": {
            "image_gallery": {
                "load_more_items": {
                    "many": "Load {{count}} more article"
                }
            }
        },
        "B2B": {
            "orders": {
                "draft_order_list": {
                    "pending_tab_accessibility_label": {
                        "pending_orders": {
                            "many": "You have {{count}} pending orders"
                        }
                    }
                }
            },
            "draft_order_details": {
                "payment_status": {
                    "pending": {
                        "banner_overdue": {
                            "many": "Payment is late by {{count}} days"
                        },
                        "banner_due": {
                            "many": "Payment is due in {{count}} days"
                        }
                    }
                }
            }
        },
        "errors": {
            "banner_title": {
                "many": "{{count}} errors occurred"
            }
        },
        "ui_components": {
            "autocompleteOptionsAvailable": {
                "many": "{{count}} items available"
            },
            "month": {
                "many": "months"
            },
            "mapClusterTitle": {
                "many": "Grouping of {{number}} indicators"
            }
        },
        "date": {
            "humanize": {
                "lessThanOneHourAgo": {
                    "many": "{{count}} minutes ago"
                }
            }
        }
    }
}
